<template>
  <footer class="bg-indigo-50/50 flex flex-col sm:flex-row w-full min-h-[400px] py-24 px-10 lg:px-32 text-gray-500 text-sm space-y-10 sm:space-y-0 sm:space-x-10">
    <div class="flex-grow">
        <div class="-m-1.5 p-1.5 flex flex-row">
          <img class="h-8 w-auto rounded-md" src="/favicon.webp" alt="logo" loading="lazy" />
          <h1 class="ml-2 text-2xl font-bold text-indigo-900">Bulba</h1>
        </div>
      <div class="space-y-4">
        <div class="mt-6">
          <p>London</p>
          <p>WC1X 0BF</p>
          <p>United Kingdom</p>
        </div>
        <div>
          <p>© 2024 REFERTO LTD.</p>
          <p>All rights reserved.</p>
        </div>
      </div>
    </div>
    <div class="flex flex-col sm:flex-row flex-grow justify-between space-y-10 sm:space-y-0 sm:space-x-5">
      <div v-for="section in sections" :key="section.name" class="text-base">
        <p class="text-lg font-bold text-gray-700">{{section.name}}</p>
        <div class="mt-6 space-y-2">
          <template v-for="item in section.content" :key="item.name" >
            <router-link v-if="item.relative" class="block" :to="item.link">{{item.name}}</router-link>
            <a v-else :href="item.link" target="_blank" class="block">{{item.name}}</a>
          </template>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
const sections = [
  {
    name: "Try Bulba",
    content: [
      {name: "Sign Up", link: "/business/signup", relative: true},
      {name: "Log In", link: "/login", relative: true},
      {name: "I'm an influencer", link: "https://apps.apple.com/gb/app/bulba-creators-x-venues/id6448395816?platform=iphone"}
    ]
  },
  {
    name: "Resources",
    content: [
      {name: "Terms of service", link: "/legal/terms-of-conditions", relative: true},
      {name: "Privacy policy", link: "/legal/privacy-policy", relative: true},
      {name: "Disclaimer", link: "/legal/disclaimer", relative: true},
      {name: "Contact support", link: "mailto:support@bulba.app"}
    ]
  },
  {
    name: "Social",
    content: [
      {name: "Instagram", link: "https://www.instagram.com/joinbulba"},
      {name: "TikTok", link: "https://www.tiktok.com/@joinbulba"},
      {name: "LinkedIn", link: "https://www.linkedin.com/company/bulba"}
    ]
  }
]
</script>
